import React from "react";
import Login from "../components/login";

const SignupPage = () => {
  return (
    <>
      <Login initialView="signup" />
    </>
  );
};

export default SignupPage;
